import { Component } from '@angular/core'

@Component({
  selector: 'flo-standings-list-skeleton',
  templateUrl: './standings-list-skeleton.component.html',
  styleUrls: ['./standings-list-skeleton.component.scss']
})
export class StandingsListSkeletonComponent {}
